import merge from "lodash/merge";
import EntityActions from "@/store/actions/entities";

const initialState = {};

export default (state = initialState, action) => {

	switch (action.type){

		case EntityActions.Load.SUCCESS:{
			return merge({}, state, action.payload);
		}

		case EntityActions.Update.SUCCESS:{
			const { entity, entityId, data } = action.payload;
			return {
				...state,
				[entity]: {
					...state[entity],
					[entityId]: {
						...state[entity][entityId],
						...data
					}
				}
			};
		}

		default:
			return state;
	}

}
